// extracted by mini-css-extract-plugin
export default {"link":"_L-z","disabled":"aM-z"};